import { __assign } from "tslib";
import { useCallback, useContext } from 'react';
import { LayerListContext } from '../context';
export function useLayerState(layer) {
    var _a = useContext(LayerListContext), selectedIds = _a.selectedIds, expandedMap = _a.expandedMap, setIsExpandedLayer = _a.setIsExpandedLayer, filter = _a.filter;
    var setIsExpanded = useCallback(function (value) {
        setIsExpandedLayer(layer.id, value);
    }, [layer.id, setIsExpandedLayer]);
    var isLayerHidden = isHidden(layer, filter);
    return {
        isSelected: !isLayerHidden && selectedIds.includes(layer.id),
        isExpanded: isExpanded(layer, expandedMap, filter),
        isHidden: isLayerHidden,
        filterText: filter.filterText,
        setIsExpanded: setIsExpanded,
    };
}
function isHidden(layer, filter) {
    return !!filter.filterText && !filter.filteredItems[layer.id];
}
function isExpanded(layer, expandedMap, filter) {
    return __assign(__assign({}, filter.filteredItems), expandedMap)[layer.id];
}
